<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b">CONTENTS</h2>
<p class="toc-entrya">      <span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-entrya">      <span href="#/xhtml/dedication" title="Link target outside of Sample">Dedication</span></p>
<p class="para"> </p>
<p class="toc-entry" id="rch1">  <a href="#/xhtml/chapter01">1. The Bridegroom Cousin</a></p>
<p class="toc-entry" id="rch2">  <span href="#/xhtml/chapter02" title="Link target outside of Sample">2. Touch My Tooth</span></p>
<p class="toc-entry" id="rch3">  <span href="#/xhtml/chapter03" title="Link target outside of Sample">3. Fear of Mosquitoes</span></p>
<p class="toc-entry" id="rch4">  <span href="#/xhtml/chapter04" title="Link target outside of Sample">4. Wounding Words</span></p>
<p class="toc-entry" id="rch5">  <span href="#/xhtml/chapter05" title="Link target outside of Sample">5. A Lingering Finish</span></p>
<p class="toc-entry" id="rch6">  <span href="#/xhtml/chapter06" title="Link target outside of Sample">6. What the Soldier Made</span></p>
<p class="toc-entry" id="rch7">  <span href="#/xhtml/chapter07" title="Link target outside of Sample">7. The Big Job</span></p>
<p class="toc-entry" id="rch8">  <span href="#/xhtml/chapter08" title="Link target outside of Sample">8. Rippling Water</span></p>
<p class="toc-entry" id="rch9">  <span href="#/xhtml/chapter09" title="Link target outside of Sample">9. Wild Thing</span></p>
<p class="toc-entry1" id="rch10"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10. The Trump Shall Sound</span></p>
<p class="toc-entry1" id="rch11"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11. And That’s Okay!</span></p>
<p class="toc-entry1" id="rch12"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12. The Raisin Bombshell</span></p>
<p class="toc-entry1" id="rch13"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13. The Therapeutic Value of Lavender</span></p>
<p class="toc-entrya" id="rapp"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Appendix: A Mennonite History Primer</span></p>
<p class="toc-entrya" id="rack"><span href="#/xhtml/backmatter02#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="para"> </p>
<p class="toc-entryb">      <span href="#/xhtml/backmatter03#bm3lev1" title="Link target outside of Sample">Meet Rhoda Janzen</span></p>
<p class="toc-entryb">      <span href="#/xhtml/backmatter03#bm3lev2" title="Link target outside of Sample">On Writing: Mennonite in a Little Black Dress</span></p>
<p class="toc-entryb">      <span href="#/xhtml/backmatter03#bm3lev3" title="Link target outside of Sample">A conversation with Rhoda Janzen</span></p>
<p class="toc-entryb">      <span href="#/xhtml/backmatter03#bm3lev4" title="Link target outside of Sample">Shame-Based Recipes</span></p>
<p class="toc-entryb">      <span href="#/xhtml/backmatter03#bm3lev5" title="Link target outside of Sample">Questions for Discussion</span></p>
<p class="toc-entryb">      <span href="#/xhtml/backmatter04#backmatter04" title="Link target outside of Sample">Reading Group Gold</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a76b676a